import { Component, Input, Output, EventEmitter } from '@angular/core';

interface Suggestion {
  displayed?: string,
  secondary?: string,
  stored?: string
}

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss']
})
export class AutocompleteComponent {

  @Input() selectedIndex: number;
  @Input() matchRegex: RegExp;
  @Input() suggestions: Suggestion[];

  @Output() selected = new EventEmitter<number>();

  selectNext() {
    if (this.selectedIndex == null) {
      this.selectedIndex = 0;
      return;
    }
    let currentIndex = this.selectedIndex;
    let lastIndex = this.suggestions.length-1;
    if (currentIndex < lastIndex) {
      this.selectedIndex = currentIndex+1;
    }
  }

  selectPrevious() {
    if (this.selectedIndex == null) {
      this.selectedIndex = 0;
      return;
    }
    let currentIndex = this.selectedIndex;
    if (currentIndex > 0) {
      this.selectedIndex = currentIndex-1;
    }
  }

  select(index: number) {
    this.selectedIndex = index;
    this.selected.emit(index);
  }

}



// WEBPACK FOOTER //
// ./src/app/forms/autocomplete.component.ts